var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgContact = function SvgContact(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.01 25.79c0 .11.09.2.2.2h31.6a.2.2 0 0 0 .2-.2V6.19a.2.2 0 0 0-.2-.2H.21a.2.2 0 0 0-.2.2zm26.44-17.5-5.55 9.6c-.04.06-.1.1-.17.1h-9.45c-.07 0-.14-.04-.17-.1l-5.55-9.6c-.08-.13.02-.3.17-.3h20.54c.16 0 .26.17.18.3M2.01 6.99h1.5l.51 2.61 5.94 10.29c.04.06.1.1.17.1h11.75c.07 0 .14-.04.17-.1L28 9.61 28.51 7h1.5v16.8a.2.2 0 0 1-.2.2H2.21a.2.2 0 0 1-.2-.2z"
  })));
};
export default SvgContact;